module.exports = __webpack_public_path__ + "img/edit.81b7bf0e.png";